import { useState } from "react";

import { makeStyles, Typography, Collapse } from "@material-ui/core";

import { OverviewTab } from "./tabs/overview";
import { OperatingPowerAssetsTab } from "./tabs/operatingPowerAssetsTab";
import { RecommendedNewPowerAssetsTab } from "./tabs/recommendedNewPowerAssetsTab";
import { HorizontalTabs } from "../../components/horizontalTabs";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: `${theme.spacing(2.5)}px ${theme.spacing(4)}px`,
    height: "100%",
    boxSizing: "border-box",
  },
  title: {
    marginBottom: theme.spacing(1.6),
    fontWeight: 400,
  },
}));

export const PowerAssetsPage = () => {
  const classes = useStyles();
  const [tab, setTab] = useState(0);

  const getActiveTabComponent = () => {
    switch (tab) {
      case 0:
        return (
          <Collapse in={tab === 0}>
            <OverviewTab />
          </Collapse>
        );
      case 1:
        return (
          <Collapse in={tab === 1}>
            <OperatingPowerAssetsTab />
          </Collapse>
        );
      case 2:
        return (
          <Collapse in={tab === 2}>
            <RecommendedNewPowerAssetsTab />
          </Collapse>
        );
      default:
        return (
          <Collapse in={tab === 0}>
            <OverviewTab />
          </Collapse>
        );
    }
  };

  return (
    <div className={classes.root}>
      <Typography className={classes.title} variant="h2">
        Portfolio Power Assets
      </Typography>

      <HorizontalTabs
        tab={tab}
        setTab={setTab}
        tabNames={[
          "Overview",
          "Operating Power Assets",
          "Recommended New Power Assets",
        ]}
      />
      {getActiveTabComponent()}
    </div>
  );
};
